import { baseApi } from './baseApi';

const vanSalesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // ── Vans ──
    getVans: builder.query({
      query: () => '/van-sales/vans',
      providesTags: ['VanSales'],
    }),
    createVan: builder.mutation({
      query: (body) => ({ url: '/van-sales/vans', method: 'POST', body }),
      invalidatesTags: ['VanSales'],
    }),
    updateVan: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/van-sales/vans/${id}`, method: 'PUT', body }),
      invalidatesTags: ['VanSales'],
    }),
    deactivateVan: builder.mutation({
      query: (id) => ({ url: `/van-sales/vans/${id}/deactivate`, method: 'POST' }),
      invalidatesTags: ['VanSales'],
    }),

    // ── Trips ──
    getVanTrips: builder.query({
      query: (params) => {
        const sp = new URLSearchParams();
        if (params?.status) sp.set('status', params.status);
        if (params?.vanId) sp.set('vanId', params.vanId);
        if (params?.fromDate) sp.set('fromDate', params.fromDate);
        if (params?.toDate) sp.set('toDate', params.toDate);
        if (params?.page) sp.set('page', params.page);
        if (params?.limit) sp.set('limit', params.limit);
        const qs = sp.toString();
        return `/van-sales/van-trips${qs ? `?${qs}` : ''}`;
      },
      providesTags: ['VanSales'],
    }),
    getVanTrip: builder.query({
      query: (id) => `/van-sales/van-trips/${id}`,
      providesTags: ['VanSales'],
    }),
    createVanTrip: builder.mutation({
      query: (body) => ({ url: '/van-sales/van-trips', method: 'POST', body }),
      invalidatesTags: ['VanSales'],
    }),
    loadTrip: builder.mutation({
      query: ({ id, items }) => ({ url: `/van-sales/van-trips/${id}/load`, method: 'POST', body: { items } }),
      invalidatesTags: ['VanSales', 'Inventory'],
    }),
    startTrip: builder.mutation({
      query: (id) => ({ url: `/van-sales/van-trips/${id}/start`, method: 'POST' }),
      invalidatesTags: ['VanSales'],
    }),
    createVanSale: builder.mutation({
      query: ({ tripId, ...body }) => ({ url: `/van-sales/van-trips/${tripId}/sale`, method: 'POST', body }),
      invalidatesTags: ['VanSales', 'Sales', 'Inventory'],
    }),
    unloadTrip: builder.mutation({
      query: ({ id, items }) => ({ url: `/van-sales/van-trips/${id}/unload`, method: 'POST', body: { items } }),
      invalidatesTags: ['VanSales', 'Inventory'],
    }),
    completeTrip: builder.mutation({
      query: (id) => ({ url: `/van-sales/van-trips/${id}/complete`, method: 'POST' }),
      invalidatesTags: ['VanSales'],
    }),
    cancelTrip: builder.mutation({
      query: (id) => ({ url: `/van-sales/van-trips/${id}/cancel`, method: 'POST' }),
      invalidatesTags: ['VanSales'],
    }),
    getTripReconciliation: builder.query({
      query: (id) => `/van-sales/van-trips/${id}/reconciliation`,
      providesTags: ['VanSales'],
    }),
    getMyActiveTrip: builder.query({
      query: () => '/van-sales/my-active-trip',
      providesTags: ['VanSales'],
    }),
  }),
});

export const {
  useGetVansQuery,
  useCreateVanMutation,
  useUpdateVanMutation,
  useDeactivateVanMutation,
  useGetVanTripsQuery,
  useGetVanTripQuery,
  useCreateVanTripMutation,
  useLoadTripMutation,
  useStartTripMutation,
  useCreateVanSaleMutation,
  useUnloadTripMutation,
  useCompleteTripMutation,
  useCancelTripMutation,
  useGetTripReconciliationQuery,
  useGetMyActiveTripQuery,
} = vanSalesApi;
